import { api, apiFile, base_url_v1, base_url_v2 } from "./api";

export const PurchaseHistoryApi = async (parms: any) => {
    let url_parms = '';
    for (let [key, value] of Object.entries(parms)) {
        if (key != 'user') {
            url_parms = `${url_parms}&${key}=${value}`
        }
        else if (key == 'user' && Array.isArray(value)) {
            for (let i of value) {
                url_parms = `${url_parms}&user_ids[]=${i}`
            }
        }
    }
    const data = await api({ url: `${base_url_v2}company/orders?${url_parms}`, method: "GET", token: true })
    return data;
}

export const PurchaseHistoryExportApi = async (id:any) => {
    const data = await apiFile({ url: `${base_url_v2}company/orders/${id}/pdf`, method: "GET", token: true })
    return data;
}


// https://core.dayan.app/api/v2/company/orders/410/pdf